{
  "title": "Vitriolic Sphere",
  "source": "Xanathar's Guide to Everything",
  "levelAndSchool": "4th-level evocation",
  "level": 4,
  "castingTime": "1 action",
  "range": "150 feet",
  "components": "V, S, M (a drop of giant slug bile)",
  "duration": "Instantaneous",
  "description": [
    "You point at a place within range, and a glowing 1-foot ball of emerald acid streaks there and explodes in a 20-foot radius. Each creature in that area must make a Dexterity saving throw. On a failed save, a creature takes 10d4 acid damage and 5d4 acid damage at the end of its next turn. On a successful save, a creature takes half the initial damage and no damage at the end of its next turn.",
    "At Higher Levels. When you cast this spell using a spell slot of 5th level or higher, the initial damage increases by 2d4 for each slot level above 4th."
  ],
  "spellLists": ["eldritch-knight", "sorcerer", "wizard"]
}
